<template>
  <button
    class="a-button"
    :class="[
      buttonRound,
      buttonFill,
      buttonBold,
      buttonSize,
      buttonDisabled,
      buttonProcessing,
      buttonPreventDefault
    ]"
    :disabled="preventDefault || processing"
  >
    <span v-if="processing" class="a-button__loading" />
    <slot v-else />
  </button>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AButton',
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    processing: {
      type: Boolean,
      default: false
    },
    round: {
      type: Boolean,
      default: false
    },
    fill: {
      type: Boolean,
      default: false
    },
    bold: {
      type: Boolean,
      default: false
    },
    preventDefault: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: '',
      validator(size) {
        return ['', 'medium'].includes(size as string);
      }
    }
  },
  computed: {
    buttonDisabled() {
      return this.disabled ? `a-button--disabled` : '';
    },
    buttonProcessing() {
      return this.disabled ? `a-button--processing` : '';
    },
    buttonRound() {
      return this.round ? `a-button--round` : '';
    },
    // TODO: 色を変数化したら「buttonFillColor」として色を自由に設定できる様にする
    buttonFill() {
      return this.fill ? `a-button--fill` : '';
    },
    buttonBold() {
      return this.bold ? `a-button--bold` : '';
    },
    buttonSize() {
      return this.size ? `a-button--size-${this.size}` : '';
    },
    buttonPreventDefault() {
      return this.preventDefault ? 'a-button--prevent-default' : '';
    }
  }
});
</script>

<style lang="scss" scoped>
.a-button {
  $this: &;

  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 13px;
  background: #fff;
  color: #0071bc;
  border: 1px solid #e6e8e9;
  border-radius: 4px;
  font-size: 13px;
  outline: none;
  &--round {
    border-radius: 100px;
  }
  &--fill {
    border: none;
    background: #0071bc;
    color: #fff;

    #{$this}__loading {
      border-color: #fff;
      border-top-color: #0071bc;
    }
  }
  &--bold {
    font-weight: 600;
  }
  &--size-medium {
    font-size: 16px;
  }
  &--disabled {
    background: #f0f1f2;
  }
  &--processing {
    cursor: not-allowed;
    pointer-events: none;
  }
  &--prevent-default {
    cursor: not-allowed;
  }
  &:hover {
    cursor: pointer;
  }
  &__loading {
    border: 3px solid $gray-scale-color-10;
    border-top: 3px solid $gray-scale-color-40;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    animation: spin 1s linear infinite;
  }
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
